import { Form } from "antd";
import { CounterpartyService } from "../../../../services/CounterpartyService";
import useFetchData from "../../../../hooks/useFetchData";
import { CounterpartyDtoRequest, CounterpartyDtoResponse } from "../../../../interfaces/CounterpartyDtos";
import { successNotification } from "../../../../helpers/successNotification";
import { useCallback } from "react";
import { debounce } from "../../../../common/debounce";

interface SelectValue {
    label: string;
    value: string;
}

const useCounterparty = (fetch: boolean = true) => {
    const [counterpartyForm] = Form.useForm();
    const { data: counterparties, fetchData: fetchCounterparties, isLoading: loading } = useFetchData<CounterpartyDtoResponse[]>(CounterpartyService.getCounterparties, fetch);

    const handleSearch = (search: string): Promise<SelectValue[]> => {
        if (search === "") {
            return Promise.resolve([]);
        }

        return CounterpartyService.getCounterparties(search)
            .then((body) =>
                body.data.map(
                    (counterparty) => ({
                        label: `${counterparty.nameRu} ${counterparty.bin}`,
                        value: counterparty.bin,
                    }),
                ),
            );
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const debouncedFetchCounterparties = useCallback(debounce(fetchCounterparties, 300), []);

    const handleAdd = (values: CounterpartyDtoRequest) => {
        CounterpartyService.createCounterparty(values)
            .then(() => {
                successNotification('Контрагент успешно добавлен!');
                fetchCounterparties();
            });
    }

    const handleEdit = (id: number, values: CounterpartyDtoRequest) => {
        CounterpartyService.updateCounterparty(id, values)
            .then(() => {
                successNotification('Контрагент успешно изменен!');
                fetchCounterparties();
            });
    }

    const handleDelete = (id: number) => {
        CounterpartyService.deleteCounterparty(id)
            .then(() => {
                successNotification('Контрагент успешно удален!');
                fetchCounterparties();
            });
    }

    return {
        handleAdd,
        handleSearch,
        counterpartyForm,
        fetchCounterparties,
        debouncedFetchCounterparties,
        counterparties,
        loading,
        handleEdit,
        handleDelete,
    }
}

export default useCounterparty;